import { render, staticRenderFns } from "./select_attachments.vue?vue&type=template&id=dac9b3ec&scoped=true"
import script from "./select_attachments.vue?vue&type=script&lang=js"
export * from "./select_attachments.vue?vue&type=script&lang=js"
import style0 from "./select_attachments.vue?vue&type=style&index=0&id=dac9b3ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dac9b3ec",
  null
  
)

export default component.exports